import styled from 'styled-components';

export const Wrapper = styled.div`
    padding: 5px;
    background: black;
    color: white;
`

export const Pre = styled.pre`
    color: white
`


// WEBPACK FOOTER //
// ./src/components/JsonViewer/Styled.js